module.exports = __webpack_public_path__ + "img/ISO27001.4591d38c.jpg";